import src from "IMAGE";
export default { src, width: 939, height: 88, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/AA0WInYMEx5pDBMeZwsTHWQaNWNCPIL4XT6E/WQ7f/NadCMJ1ofWSnMAAAAASUVORK5CYII="};
